class SubmitProposalNotify {
  static getEmailData = (dst, user, userSend, project) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Propuesta de Proyecto Enviada para Revisión`;
    const body = templateData(user, userSend, project);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default SubmitProposalNotify;

const templateData = (user, userSend, project) => {
  const generateCommentsTable = () => {
    const comments = project.comments || [];

    if (comments.length === 0) {
      return '<p>No hay comentarios.</p>';
    }

    let tableRows = comments
      .map((comment) => {
        return `
        <tr>
          <td>${comment.user.displayName}</td>
          <td>${comment.text}</td>
          <td>${comment.type}</td>
          <td>${comment.createAt}</td>
        </tr>
      `;
      })
      .join('');

    return `
      <table style="width:100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Comentario</th>
            <th>Tipo</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    `;
  };

  return `
      <h2 style="text-align: center;">
        Propuesta de Proyecto Enviada para Revisión
      </h2>
      <br />
      <p>Estimado(a) ${userSend?.displayName},</p>
      <br />
      <p>
        Te informamos que se ha enviado una propuesta para tu proyecto. A continuación, se presentan algunos detalles del proyecto:
      </p>
      <br />
      <p> 
        <h3>${project.ministerio}</h3>
        <p><strong>Datos de contacto:</strong> 
          ${user?.email} - ${user?.phoneNumber}
        </p>
        <p><strong>Título:</strong> 
          ${project.title}
        </p>
        <p><strong>Descripción:</strong> 
          ${project.resumenProyecto}
        </p>
      </p>
      <br />
      <p>
        <h3>Comentarios:</h3>
        ${generateCommentsTable()}
      </p>
      <br />
      <p>
        Para revisar la propuesta, visita el Portal y revisa tus pendientes <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>.
      </p>
      <br />
      <br />
      <p>Saludos,</p>
      <br />
      <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
    `;
};
